import black from './black';
import gray from './grey';
import { TypeText } from './types';

const text: TypeText & { hint: string } = {
  primary: black[900],
  secondary: black[700],
  hint: black[600],
  disabled: black[400],
  contrast: gray[200],
  dark: black[900],
};

export default text;
